/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 // SUBTITLE INSTAFEED

//  const instafeedSubtitle = `<p class="instafeedSubtitle"> Our </p>`;

//  window.addEventListener('load', function() {
//    const instafeed = document.querySelector('.instagenie-feed');
//    instafeed.insertAdjacentHTML('afterBegin', instafeedSubtitle);
// });

// MAIN PAGE ACCORDION

(function () {
  const acc = document.getElementsByClassName('faqs-title');
  let i;
 
  for (i = 0; i < acc.length; i++) {
     acc[i].addEventListener('click', function () {
         this.classList.toggle('active');
         let panel = this.nextElementSibling;
         if (panel.style.maxHeight) {
             panel.style.maxHeight = null;
         } else {
             panel.style.maxHeight = panel.scrollHeight + 'px';
         }
     });
 }
})()


// PRODUCT PAGE  ACCORDION

const accProduct = document.querySelectorAll('.faqs-title_product-page');

accProduct.forEach((item) => {
  item.addEventListener('click', function () {
        this.classList.toggle('activeP');
         let panelP = this.nextElementSibling;
         if (panelP.style.maxHeight) {
             panelP.style.maxHeight = null;
         } else {
             panelP.style.maxHeight = panelP.scrollHeight + 'px';
         }
     });
});

// FOOTER LANGUAGE SWITCH

  document.querySelectorAll("#localeItem").forEach(item => {
    item.addEventListener("click", event=>{
      document.getElementById("localeCode").value = item.getAttribute("lang");
      document.getElementById("localization_form_tag").submit();
    })
  })

// PINK COLOR SHOP ALL

const linkUnderlinePink = document.querySelectorAll(".link_underline_pink ");
for (let item of linkUnderlinePink){
  if(item.innerHTML.replace(/ /g,'').toLowerCase() == "shopall"){
    item.style.borderTop = '1px solid #dfdfdfa1';
    item.style.width = '100%';
    item.style.paddingTop = '10px';
    item.classList.add("link_not_underline");
  }
};


// FORM PRODUCT PAGE

window.addEventListener('load', function() {
  // let formText = document.querySelectorAll('.mw-option');
  let formText = document.querySelectorAll('.mw-option--type-select');
  const waitForFormText = setInterval(() => {
    formText = document.querySelectorAll('.mw-option--type-select');
    if (formText.length > 0) {
      clearInterval(waitForFormText);
      formText.forEach(element => {
        const formLabel = element.querySelector('.mw-text');
        const formSelect = element.querySelector('[data-hidden]');
        const mwOptionControl = element.querySelector('.mw-option__control');
        formSelect.innerText = `${formLabel.innerText}`;
        mwOptionControl.style.display = 'block';
        const mwStackItem = document.querySelectorAll('.mw-stack__item--fill');
        mwStackItem.forEach(item => {
          const arrow = `<div class="select-arrow">
            <svg class="select-arrow_svg" role="presentation" viewBox="0 0 19 12">
              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
            </svg>
          </div>`;
          item.insertAdjacentHTML('afterbegin', arrow);
        });
      });
    }
  }, 100);
});


// Custom icon Size Guide

 window.addEventListener('load', function() {
    const waitMuiBox = setInterval(() => {
     const muiBox = document.querySelectorAll('.MuiBox-root');
     if (muiBox.length > 0) {
       clearInterval(waitMuiBox);
        const sizeGuideIcon = `<div class="sizeGuideIcon">
             <img src="https://cdn.shopify.com/s/files/1/0674/8638/4442/files/photo_2023-02-08_12-54-35.jpg?v=1675881069" alt="Size Guide">
          </div>`;
         muiBox[0].insertAdjacentHTML('afterbegin', sizeGuideIcon);
     }
   }, 100);
});

// ANCHORS 

const anchors = document.querySelectorAll('a[href*="#"]')
for (let anchor of anchors) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    
    const blockID = anchor.getAttribute('href').substr(1)
    
    document.getElementById(blockID).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  })
}

// hide skeleton on product page

window.onload = () => {
  if (document.body.classList.contains('template-product')) {
    document.querySelector('.skeleton_wr').classList.add('hidden')
    document.querySelector('.mw_style').remove()
  }
}

// toggle table on size guide page

const btns = document.querySelectorAll('.size_guide__btn')

btns.forEach(el => {
  const value = el.dataset.value
  el.addEventListener('click', () => {
    
    el.parentElement.querySelectorAll('.size_guide__btn').forEach(btn => {
      btn.classList.remove('selected')
    })
    el.classList.add('selected')
    el.closest('.size_guide__content').querySelectorAll(`table[data-table-value]`).forEach(table => {
      table.classList.remove('selected')
    })
    el.closest('.size_guide__content').querySelector(`[data-table-value="${value}"]`).classList.add('selected')
  })
})

// wishlist counter

function renderWishlistCounter(swat) {
	var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Custom header can be added here.*/
	if (counter_elem) {
		for (var i = 0; i < counter_elem.length; i++) {
			if (swat.renderWishlistCount) {
				swat.renderWishlistCount(counter_elem[i], function(count, element) {
				});
			}
		}
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter); 

// link in measurements's input
(function () {

  if (document.body.classList.contains('template-product')) {
    const lineItemsContainer = document.querySelector('.hidden_line_items')
    async function getMeasurements(code) {
        const token = 'hOjUDx5PcA1hbqBCqmnU6FihTYnCqKflBrJZyY84xWyYCzVAG272dMJ2uWFcH2NTrjRdxTVAP0GizLPH884KhmEWVsSeVSNGKXbZuacHoDz50Bouy05TLZfrqV3Xhnlj';
        const url = 'https://measurements.brightandshinystore.com/index.php?route=api/measurements';
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`
            }
        };

        // Добавляем POST данные
        const formData = new URLSearchParams();
        formData.append('code', code);
        params.body = formData;

        // Выполнение запроса
        try {
            const response = await fetch(url, params);
            const responseData = await response.json();

            if (responseData.error) {
                console.log('Ошибка получения мерок:', responseData.error);
            } else if (responseData) {
                console.log('Мерки успешно получены:', responseData);
               
                lineItemsContainer.innerHTML += `
                  <input type="text" name="properties[- Gender]" value="${responseData.gender}">
                `

                responseData.measurements.forEach((element, index) => {
                  lineItemsContainer.innerHTML += `
                    <input type="text" name="properties[- ${index + 1}. ${element.name}]" value="${element.value}">
                  `
                });
                console.log(lineItemsContainer)
              
            }
        } catch (error) {
            console.log('Ошибка получения мерок:', error);
            throw error;
        }
    }

   


    window.addEventListener('load', function() {
      setTimeout(() => {
        const inputContainer = document.querySelector('.measurements .mw-option__control').closest('.mw-stack__item')
  
        const element = document.createElement('div')
        element.classList.add('measurements__link')
        element.innerHTML = '<a href="http://measurements.brightandshinystore.com" target="_blank">Submit you measurements to get an ID</a>'
        inputContainer.insertAdjacentElement('beforebegin', element)


        document.querySelector('.measurements input').addEventListener('change', (input) => {
          console.log(input.target.value)
           getMeasurements(input.target.value);
        })
      }, 2000);
    });
  }
})();

// set author on instagram's section
(function () {
  window.addEventListener('load', () => {
    setTimeout(() => {
      // const targets = document.querySelectorAll('.instafeed-container')
      const content = document.querySelectorAll('.instafeed-caption')
      content.forEach((element) => {
        const container = element.closest('.lightbox-instagram')
        const text = element.textContent 
        const username = text.match(/@\w.+/)[0].substr(1);  
        const newDiv = document.createElement("a");
        newDiv.setAttribute('href', `https://www.instagram.com/${username}`)
        newDiv.setAttribute('target', '_blank')
        newDiv.classList.add('instafeed-username')

        const newContent = document.createTextNode(`@${username}`);
        
        newDiv.appendChild(newContent);

        // const clone = newDiv.cloneNode(true);
        // targets[index].appendChild(newDiv); 
        container.appendChild(newDiv); 
      });
    }, 2000);
    
  })
})();
// set author on instagram's section